import { render, staticRenderFns } from "./TifNovedades.vue?vue&type=template&id=2f5e2c7c"
import script from "./TifNovedades.vue?vue&type=script&lang=js"
export * from "./TifNovedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports